export default "__VITE_ASSET__B$cNUCSj__"